import React, { ReactNode } from "react";

import { ErrorHelper } from "@/common/helpers/error";

/** Catches unhandled errors related to dynamic imports in lazy-loaded React components and displays a fallback UI.
 * It mostly occurs due to HTTP 404 when fetching a JS chunk,
 * that does not exist anymore after the app was updated (i.e. Vite rebuild and chunk name changed).
 * https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 * */
export class DynamicImportErrorBoundary extends React.Component<
  { fallback?: ReactNode; children: ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(err: Error) {
    return { hasError: ErrorHelper.isDynamicImportFetchError(err) };
  }

  componentDidCatch(err: Error, info: React.ErrorInfo) {
    console.error("Dynamic import failed:", info, err);
    console.dir(err);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
